import { createGlobalStyle } from "styled-components";

import { color, cssVariable } from "./color";
import type { ColorName } from "./color";
import type { Theme } from "./themes";

function variables(theme: Theme): string {
    return Object.entries(theme)
        .map(([name, value]) => `${cssVariable(name as ColorName)}: ${value};`)
        .join("\n");
}

/** Puts the theme's colours in CSS variables, and sets the page's basic styles. */
export const ThemeStyle = createGlobalStyle<{ colors: Theme; dark: boolean }>`
    :root {
        ${({ colors }) => variables(colors)}
        color-scheme: ${({ dark }) => (dark ? "dark" : "light")};
    }

    *, *::before, *::after {
        box-sizing: border-box;
    }

    html, body, #root {
        height: 100%;
        margin: 0;
    }

    body {
        background: ${color.background};
        color: ${color.text};
        font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
        -webkit-font-smoothing: antialiased;
        -webkit-tap-highlight-color: transparent;
    }

    button, input, textarea, select {
        font: inherit;
        color: inherit;
    }

    a {
        color: ${color.accent};
    }

    @media (prefers-reduced-motion: reduce) {
        *, *::before, *::after {
            animation: none !important;
            transition: none !important;
        }
    }
`;
